import { render, staticRenderFns } from "./CamaraEnVivoOperacionesPantalla.vue?vue&type=template&id=7628e7f6&scoped=true&"
import script from "./CamaraEnVivoOperacionesPantalla.vue?vue&type=script&lang=ts&"
export * from "./CamaraEnVivoOperacionesPantalla.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraEnVivoOperacionesPantalla.vue?vue&type=style&index=0&id=7628e7f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7628e7f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7628e7f6', component.options)
    } else {
      api.reload('7628e7f6', component.options)
    }
    module.hot.accept("./CamaraEnVivoOperacionesPantalla.vue?vue&type=template&id=7628e7f6&scoped=true&", function () {
      api.rerender('7628e7f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/EnVivo/CamaraEnVivoOperacionesPantalla.vue"
export default component.exports